/**
 * Client for the general (PMS) repricing Strategies API.
 *
 * Replaces the calls to `BACKEND_APIS.DS_REPRICING`
 * (`/api/pricing-tool/ds/*`), which write the legacy `DS_REPRICING`
 * table with `uid` tenancy — the AutoEurope repricing. This screen now
 * writes the canonical `repricing_strategy*` tables with `company`
 * tenancy (CU-869f043c1). The legacy blueprint keeps its own rows; it
 * simply has no caller from here any more.
 */
import { BACKEND_APIS } from '@constants/routes'
import { makeClient, resource } from 'Pages/DsRepricing/@services/http'

export { ApiError } from 'Pages/DsRepricing/@services/http'

export const API = BACKEND_APIS.GENERAL_REPRICING_STRATEGIES_API

const http = makeClient(API)
const strategies = resource(http, '')

export const strategiesApi = {
	list:   strategies.list,
	get:    strategies.get,
	create: strategies.create,
	update: strategies.update,
	remove: strategies.remove,
	setStatus: (id, status, reason) => http.put(`/${id}/status`, { status, reason }),
	/** Advisory pre-save check; create/update re-evaluate it server-side. */
	overlapCheck: (dto, id) => http.post('/overlap-check', { id: id || null, strategy: dto }),
}
